import { render, staticRenderFns } from "./JoinSection.vue?vue&type=template&id=7c707aa0&scoped=true"
import script from "./JoinSection.vue?vue&type=script&lang=js"
export * from "./JoinSection.vue?vue&type=script&lang=js"
import style0 from "./JoinSection.vue?vue&type=style&index=0&id=7c707aa0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c707aa0",
  null
  
)

export default component.exports